module.exports = __webpack_public_path__ + "static/images/styles/images/icons/industrial-resource.1a3d9576.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/industrial-resource.png
// module id = 3639
// module chunks = 11